define('CustomMyAccountData.Model',	[
  'Backbone.CachedModel',
  'underscore',
  'Utils'
],	function
(
  BackboneCachedModel,
  _,
  Utils
) {
  'use strict';

  var CustomMyAccountDataModel = BackboneCachedModel.extend({
    urlRoot: Utils.getAbsoluteUrl( getExtensionAssetsPath('services/CustomMyAccountData.Service.ss'))
  });

  return CustomMyAccountDataModel;

});
